<template>
    <i :class="'icon el-icon-' + source"></i>
</template>

<script>
export default {
    name: 'Icon',
    props: ['source'],
    methods: {
        //
    },
};
</script>
